<script>
import PriceListSection from "./priceListSection.vue";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import AssociatedFeeSection from "./associatedFeeSection.vue";
import FloorPlanSwiper from "./floorPlanSwiper.vue";
import trackAction from '@/utils/action';

export default {
  name: "listingDetailsTabs",
  components: {
    AssociatedFeeSection,
    PriceListSection,
    swiper,
    swiperSlide,
    FloorPlanSwiper
  },
  data() {
    return {
      userToken: '',
      startTime: Date.now(),
      tabTimeList: [],
      tabViewList: [],
      currentLabel: 'Property Details',
      timer: '',
      tabPosition: "bottom",
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          loop: true
        },
        loop: true,
        on: {
          slideChangeTransitionEnd: function() {
            self.initialSlide = this.activeIndex + 1;
          }
        },
        observer: true,
        observeParents: true
      }
    };
  },
  props: {
    propsImage: Object,
    listFloorPlan: Array,
    currentRoom: Object
  },
  mounted() {},
  beforeDestroy() {
    this.tabChange({ label: this.currentLabel }, 1)
  },
  created() {
    this.userToken = localStorage.getItem("token");
  },
  methods: {
    updateRow(row) {
      this.$emit("updateRow", row);
    },
    tabChange(context, type) {
      const currentTime = Date.now();
      const val = {
        "actionCount": 0,
        "duration": parseInt((currentTime - this.startTime) / 1000) < 1 ? 1 : parseInt((currentTime - this.startTime) / 1000).toFixed(0),
        "elementAction": "Time on Tab",
        "elementName": type === 1 ? context.label : this.currentLabel,
        "endTime": currentTime,
        "propertyId": this.currentRoom.propertyId,
        "startTime": this.startTime
      }
      this.trackTabTime(val)
      this.tabViewList.push({
        "actionCount": 1,
        "duration": 0,
        "elementAction": "Tab Views",
        "propertyId": this.currentRoom.propertyId,
        "endTime": 0,
        "elementName": type === 1 ? context.label : this.currentLabel,
        "startTime": 0
      })
      this.currentLabel = context.label
      this.startTime = Date.now();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    trackTabTime(val) {
      this.tabTimeList.push(val)
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        trackAction("list", [...this.tabTimeList, ...this.tabViewList], 'tab time');
        this.tabTimeList = []
        this.tabViewList = []
      }, 5000);
    }
  }
};
</script>

<template>
  <el-row class="tabs-customized" style="background-color: #101010">
    <el-col :span="24">
      <el-card
        :body-style="{ padding: '0px' }"
        shadow="never"
        style="border: 0 none; border-radius: initial"
      >
        <div
          slot="header"
          :style="
            'padding: 0; background-color: ' +
              propsImage.companyColour +
              '; display: flex; justify-content: center'
          "
        >
          <div
            :style="{
              backgroundImage: `url(${propsImage.companyLogoUrl} ? ${propsImage.companyLogoUrl} : '')`
            }"
            class="logo-showing"
            style="display: flex; align-content: center"
          >
            <el-image
              :fit="'contain'"
              :src="propsImage.companyLogoUrl"
              style="height: 30px; padding: 5px 0;"
            />
          </div>
        </div>
        <el-tabs :tab-position="tabPosition" @tab-click="tabChange" style="max-height: 550px;">
          <!--          Property Details Tab-->
          <el-tab-pane label="Property Details" style="height: 490px;">
            <div class="swiper-wrap">
              <swiper
                v-if="propsImage.imgLst && propsImage.imgLst.length > 1"
                ref="mySwiper"
                :options="swiperOption"
              >
                <swiper-slide
                  v-for="(item, index) in propsImage.imgLst"
                  :key="index"
                >
                  <div
                    :style="{ backgroundImage: 'url(' + item + ')' }"
                    class="img"
                  >
                    <el-image :src="item" :style="{ opacity: 0, width: '100%', height: '100%' }"
                              :scroll-container="true"
                              :preview-src-list="propsImage.imgLst" />
                  </div>
                </swiper-slide>
                <div
                  slot="button-prev"
                  class="swiper-button-prev"
                  @click.prevent
                ></div>
                <div
                  slot="button-next"
                  class="swiper-button-next"
                  @click.prevent
                ></div>
              </swiper>
              <swiper
                v-if="propsImage.imgLst && propsImage.imgLst.length == 1"
                ref="mySwiper"
                :options="swiperOption"
              >
                <swiper-slide
                  v-for="(item, index) in propsImage.imgLst.concat(
                    propsImage.imgLst
                  )"
                  :key="index"
                >
                  <div
                    :style="{ backgroundImage: 'url(' + item + ')' }"
                    class="img"
                  >
                    <el-image :src="item" :style="{ opacity: 0, width: '100%', height: '100%' }"
                              :preview-src-list="propsImage.imgLst" />
                  </div>
                </swiper-slide>
                <div
                  slot="button-prev"
                  class="swiper-button-prev"
                  @click.prevent
                ></div>
                <div
                  slot="button-next"
                  class="swiper-button-next"
                  @click.prevent
                ></div>
              </swiper>
            </div>
          </el-tab-pane>
          <!--          Video Tab-->
          <el-tab-pane
            v-if="propsImage.videoUrl"
            label="Video"
            style="height: 490px;"
          >
            <iframe
              :src="propsImage.videoUrl"
              height="100%"
              width="100%"
            ></iframe>
          </el-tab-pane>
          <!--          Floor Plans Tab-->
          <el-tab-pane :label="this.propsImage.proertyType == 'Land' ? 'Individual Plans' : 'Floor Plans' " style="height: 490px;">
            <floor-plan-swiper :listFloorPlan="listFloorPlan" />
          </el-tab-pane>
          <!--          Pricelist Tab-->
          <el-tab-pane
            label="Pricelist"
            style="height: 490px; overflow-y: scroll;"
          >
            <price-list-section
              v-if="propsImage.propertyId"
              :props-data="propsImage.listRoom"
              :props-proerty="propsImage.proertyType"
              :current="currentRoom"
              @updateRow="updateRow"
            />
          </el-tab-pane>
          <!--          Site Plans Tab-->
          <el-tab-pane
            v-if="propsImage.sitePlans"
            :style="
              !propsImage.sitePlans.endsWith('.pdf')
                ? { overflowY: 'scroll' }
                : ''
            "
            label="Site Plans"
            style="height: 490px;"
          >
            <el-row>
              <el-col
                :span="24"
                style="display: flex;justify-content: center; max-height: 490px"
              >
                <el-image
                  v-if="!propsImage.sitePlans.endsWith('.pdf')"
                  :preview-src-list="[propsImage.sitePlans]"
                  :src="propsImage.sitePlans"
                  style="height: 100%"
                />
                <embed
                  v-else
                  :src="propsImage.sitePlans"
                  height="490"
                  type="application/pdf"
                  width="100%"
                />
              </el-col>
            </el-row>
          </el-tab-pane>

          <!--          Specifications Tab-->
          <el-tab-pane
            v-if="propsImage.specifications"
            :style="
              !propsImage.specifications.endsWith('.pdf')
                ? { overflowY: 'scroll' }
                : ''
            "
            label="Specifications"
            style="height: 490px;"
          >
            <el-image
              v-if="!propsImage.specifications.endsWith('.pdf')"
              :preview-src-list="[propsImage.specifications]"
              :src="propsImage.specifications"
              class="img-6"
            />
            <embed
              v-else
              :src="propsImage.specifications"
              height="490"
              type="application/pdf"
              width="100%"
            />
          </el-tab-pane>
          <!--          The Builder Tab-->
          <el-tab-pane
            v-if="propsImage.informationPack"
            :style="
              !propsImage.informationPack.endsWith('.pdf')
                ? { overflowY: 'scroll' }
                : ''
            "
            label="The Builder"
            style="height: 490px;"
          >
            <el-image
              v-if="!propsImage.informationPack.endsWith('.pdf')"
              :preview-src-list="[propsImage.informationPack]"
              :src="propsImage.informationPack"
              class="img-6"
            />
            <embed
              v-else
              :src="propsImage.informationPack"
              height="490"
              type="application/pdf"
              width="100%"
            />
          </el-tab-pane>
          <!--          Associated Fees Tab-->
          <el-tab-pane
            v-if="propsImage.associatedFees"
            :style="
              !propsImage.associatedFees.endsWith('.pdf')
                ? { overflowY: 'scroll' }
                : ''
            "
            label="Associated Fees"
            style="height: 490px;"
          >
            <el-image
              v-if="!propsImage.associatedFees.endsWith('.pdf')"
              :preview-src-list="[propsImage.associatedFees]"
              :src="propsImage.associatedFees"
              class="img-6"
            />
            <embed
              v-else
              :src="propsImage.associatedFees"
              width="100%"
              height="490"
              type="application/pdf"
            />
          </el-tab-pane>
          <!--          Associated Fee Tab-->
          <el-tab-pane
            style="height: 490px; overflow-y: scroll;"
            label="Associated Fees"
          >
            <associated-fee-section
              :props-data="propsImage.listRoom"
              :props-proerty="propsImage.proertyType"
            />
          </el-tab-pane>
          <!--          Rental Appraisal Tab-->
          <el-tab-pane
            v-if="propsImage.rentalAppraisal"
            :style="
              !propsImage.rentalAppraisal.endsWith('.pdf')
                ? { overflowY: 'scroll' }
                : ''
            "
            label="Rental Appraisal"
            style="height: 490px;"
          >
            <el-image
              v-if="!propsImage.rentalAppraisal.endsWith('.pdf')"
              :preview-src-list="[propsImage.rentalAppraisal]"
              :src="propsImage.rentalAppraisal"
              class="img-6"
            />
            <embed
              v-else
              :src="propsImage.rentalAppraisal"
              height="490"
              type="application/pdf"
              width="100%"
            />
          </el-tab-pane>
          <!--          Tax Depreciation Schedule Tab-->
          <el-tab-pane
            v-if="propsImage.tax"
            :style="
              !propsImage.tax.endsWith('.pdf') ? { overflowY: 'scroll' } : ''
            "
            label="Tax Depreciation Schedule"
            style="height: 490px;"
          >
            <el-image
              v-if="!propsImage.tax.endsWith('.pdf')"
              :preview-src-list="[propsImage.tax]"
              :src="propsImage.tax"
              class="img-6"
            />
            <embed
              v-else
              :src="propsImage.tax"
              height="490"
              type="application/pdf"
              width="100%"
            />
          </el-tab-pane>
          <!--          Comparable Sales Tab-->
          <el-tab-pane
            v-if="propsImage.valuation"
            style="height: 490px;"
            :style="
              !propsImage.valuation.endsWith('.pdf')
                ? { overflowY: 'scroll' }
                : ''
            "
            label="Comparable Sales"
          >
            <el-image
              v-if="!propsImage.valuation.endsWith('.pdf')"
              :src="propsImage.valuation"
              :preview-src-list="[propsImage.valuation]"
              class="img-6"
            />
            <embed
              v-else
              :src="propsImage.valuation"
              width="100%"
              height="490"
              type="application/pdf"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<style scoped>
.img-6 {
  object-position: center;
  width: 100%;
}

.el-card /deep/ .el-card__header {
  padding: 0 !important;
  border-bottom: none;
}

.el-tabs /deep/ .el-tabs__nav-scroll {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis, sans-serif;
  font-size: 18px;
  color: #2d2d2d;
  background-color: #f5f5f5;
  font-weight: 400;
  padding: 5px 0;
}

.el-tab-pane /deep/ .el-image {
  height: 100%;
}

.swiper-wrap {
  width: 100%;
  height: 490px;

  .img {
    width: 100%;
    height: 490px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: #3f3f46;
    cursor: pointer;
  }
}

.el-image-viewer__canvas {
  background-color: rgba(0, 0, 0, 0.8);
}

.el-image-viewer__wrapper /deep/ .el-image-viewer__canvas {
  background-color: rgba(0, 0, 0, 0.8);
}

.logo-showing {
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

.el-tabs {
  .el-tabs__nav-next {
    color: #ffffff;
    background-color: #003333;
    height: 100%;
  }
  .el-tabs__nav-prev {
    color: #ffffff;
    background-color: #003333;
    height: 100%;
  }
  .el-tabs__nav-scroll {
    background-color: #003333;
    color: #ffffff;
  }
  .el-tabs__item {
    color: #ffffff;
  }
  .el-tabs__active-bar {
    background-color: #ffffff;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/listingDetailsTabs.vue